// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Device Inventory Card */
.device-inventory-card {
  background: #000000;
  border: 2px solid #1f2937;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.device-inventory-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: transparent;
  transition: background 0.3s ease;
}

.device-inventory-card:hover {
  border-color: #374151;
  background: #0a0a0a;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
}

.device-inventory-card.has-selection::before {
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
}

/* Variants */
.device-inventory-card-primary:hover {
  border-color: rgba(59, 130, 246, 0.5);
}

.device-inventory-card-secondary:hover {
  border-color: rgba(107, 114, 128, 0.5);
}

.device-inventory-card-success:hover {
  border-color: rgba(34, 197, 94, 0.5);
}

.device-inventory-card-warning:hover {
  border-color: rgba(251, 146, 60, 0.5);
}

.device-inventory-card-info:hover {
  border-color: rgba(59, 130, 246, 0.5);
}

/* Header */
.device-inventory-card-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}

.device-inventory-card-icon-wrapper {
  flex-shrink: 0;
}

.device-inventory-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.device-inventory-card-icon-primary {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.device-inventory-card-icon-secondary {
  background: linear-gradient(135deg, #6b7280, #4b5563);
}

.device-inventory-card-icon-success {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.device-inventory-card-icon-warning {
  background: linear-gradient(135deg, #fb923c, #f97316);
}

.device-inventory-card-icon-info {
  background: linear-gradient(135deg, #06b6d4, #0891b2);
}

.device-inventory-card-content {
  flex: 1 1;
}

.device-inventory-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #f3f4f6;
  margin: 0 0 6px 0;
}

.device-inventory-card-description {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
  line-height: 1.4;
}

.device-inventory-card-arrow {
  color: #6b7280;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.device-inventory-card:hover .device-inventory-card-arrow {
  color: #93c5fd;
  transform: translateX(4px);
}

/* Footer */
.device-inventory-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid #1f2937;
}

.device-inventory-card-stats {
  display: flex;
  gap: 20px;
  flex: 1 1;
}

.device-inventory-card-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-label {
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #f3f4f6;
  transition: color 0.3s ease;
}

.stat-value.active {
  color: #60a5fa;
}

/* Badge */
.device-inventory-card-badge {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-success {
  background: rgba(34, 197, 94, 0.15);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.badge-warning {
  background: rgba(251, 146, 60, 0.15);
  color: #fdba74;
  border: 1px solid rgba(251, 146, 60, 0.3);
}

/* Grid Layout for Cards */
.device-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .device-cards-grid {
    grid-template-columns: 1fr;
  }

  .device-inventory-card-header {
    gap: 12px;
  }

  .device-inventory-card-icon {
    width: 40px;
    height: 40px;
  }

  .device-inventory-card-title {
    font-size: 16px;
  }

  .device-inventory-card-footer {
    flex-direction: column;
    align-items: flex-start;
  }

  .device-inventory-card-stats {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DeviceInventoryCard.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA,aAAa;AACb;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Device Inventory Card */\n.device-inventory-card {\n  background: #000000;\n  border: 2px solid #1f2937;\n  border-radius: 12px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n.device-inventory-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: transparent;\n  transition: background 0.3s ease;\n}\n\n.device-inventory-card:hover {\n  border-color: #374151;\n  background: #0a0a0a;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);\n}\n\n.device-inventory-card.has-selection::before {\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6);\n}\n\n/* Variants */\n.device-inventory-card-primary:hover {\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n.device-inventory-card-secondary:hover {\n  border-color: rgba(107, 114, 128, 0.5);\n}\n\n.device-inventory-card-success:hover {\n  border-color: rgba(34, 197, 94, 0.5);\n}\n\n.device-inventory-card-warning:hover {\n  border-color: rgba(251, 146, 60, 0.5);\n}\n\n.device-inventory-card-info:hover {\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n/* Header */\n.device-inventory-card-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.device-inventory-card-icon-wrapper {\n  flex-shrink: 0;\n}\n\n.device-inventory-card-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.device-inventory-card-icon-primary {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n}\n\n.device-inventory-card-icon-secondary {\n  background: linear-gradient(135deg, #6b7280, #4b5563);\n}\n\n.device-inventory-card-icon-success {\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n}\n\n.device-inventory-card-icon-warning {\n  background: linear-gradient(135deg, #fb923c, #f97316);\n}\n\n.device-inventory-card-icon-info {\n  background: linear-gradient(135deg, #06b6d4, #0891b2);\n}\n\n.device-inventory-card-content {\n  flex: 1;\n}\n\n.device-inventory-card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #f3f4f6;\n  margin: 0 0 6px 0;\n}\n\n.device-inventory-card-description {\n  font-size: 14px;\n  color: #9ca3af;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.device-inventory-card-arrow {\n  color: #6b7280;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.device-inventory-card:hover .device-inventory-card-arrow {\n  color: #93c5fd;\n  transform: translateX(4px);\n}\n\n/* Footer */\n.device-inventory-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #1f2937;\n}\n\n.device-inventory-card-stats {\n  display: flex;\n  gap: 20px;\n  flex: 1;\n}\n\n.device-inventory-card-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #9ca3af;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.stat-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #f3f4f6;\n  transition: color 0.3s ease;\n}\n\n.stat-value.active {\n  color: #60a5fa;\n}\n\n/* Badge */\n.device-inventory-card-badge {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.badge-success {\n  background: rgba(34, 197, 94, 0.15);\n  color: #86efac;\n  border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.badge-warning {\n  background: rgba(251, 146, 60, 0.15);\n  color: #fdba74;\n  border: 1px solid rgba(251, 146, 60, 0.3);\n}\n\n/* Grid Layout for Cards */\n.device-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n  margin-top: 20px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .device-cards-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .device-inventory-card-header {\n    gap: 12px;\n  }\n\n  .device-inventory-card-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .device-inventory-card-title {\n    font-size: 16px;\n  }\n\n  .device-inventory-card-footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .device-inventory-card-stats {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
